import { render, staticRenderFns } from "./bindSuccess.vue?vue&type=template&id=42f64c82&scoped=true"
import script from "./bindSuccess.vue?vue&type=script&lang=js"
export * from "./bindSuccess.vue?vue&type=script&lang=js"
import style0 from "./bindSuccess.vue?vue&type=style&index=0&id=42f64c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f64c82",
  null
  
)

export default component.exports